// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.0-beta.2f183e30c',
  revision: '2f183e30c',
  branch: 'develop',
  date: 'Wed, 15 Jul 2026 14:46:26 GMT'
};